﻿'use strict';

angular.module('ntmApp')
  .directive('timeEditor', function () {
      return {
          restrict: 'E',
          templateUrl: 'ng1/src/directives/templates/timeEditor.html',
          scope: {
              model: '=',
              disabled: '=',
              required: '='
          },
          link: function (scope) {
              if (angular.isNumber(scope.model)) {

                  var time = parseFloat(scope.model);
                  scope.hours = (time / 60) >> 0; // jshint ignore:line
                  scope.minutes = parseInt((time % 60).toFixed());
              }

              scope.$watchGroup(['hours', 'minutes'], function () {
                  if (scope.required) {
                      if (!scope.hours && !scope.minutes || scope.minutes > 60) {
                          scope.model = scope.hours = scope.minutes = null;
                          scope.isRequired = true;
                          return;
                      }
                  } else {
                      scope.isRequired = false;
                  }

                  scope.model = parseInt(scope.hours || 0) * 60 + parseInt(scope.minutes || 0);
              });
             


          }
      };
  });